import React from 'react'
import type { JSX } from 'react'

import type { DrawerButtonIntent } from './drawer-button-intent'

export function DrawerFullWidthButton({
  children,
  intent,
  onClick,
}: {
  readonly children: React.ReactNode
  readonly intent: DrawerButtonIntent
} & Required<Pick<JSX.IntrinsicElements['button'], 'onClick'>>) {
  return (
    <button
      className={`w-full py-4 border-t border-acorns-ivory contrast-more:border-acorns-stone-light font-demibold text-body text-center focus:outline-none cursor-pointer ${
        intent === 'positive'
          ? 'text-acorns-green contrast-more:text-acorns-ada-dark-green'
          : intent === 'secondary'
            ? 'text-acorns-stone'
            : intent === 'destructive'
              ? 'text-error'
              : 'text-acorns-slate'
      }`}
      onClick={onClick}
      type={'button'}
    >
      {children}
    </button>
  )
}
